import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../api';
import { Department } from '../../types/agentTypes';

const DEPARTMENTS_QUERY_KEY = ['departments'];

export const useDepartments = () => {

  // Query for fetching departments
  const {
    data: departments = [],
    isLoading: isLoadingDepartments,
    error: departmentError,
    refetch: fetchDepartments,
  } = useQuery<Department[]>({
    queryKey: DEPARTMENTS_QUERY_KEY,
    queryFn: apiClient.department.fetchDepartmentsList,
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
  });

  return {
    // Data
    departments,
    isLoadingDepartments,
    departmentError: departmentError?.message || null,

    // Actions
    fetchDepartments,
  };
};
